import { render, staticRenderFns } from "./Tele2InternetPage.vue?vue&type=template&id=788e59d9&scoped=true&"
import script from "./Tele2InternetPage.vue?vue&type=script&lang=js&"
export * from "./Tele2InternetPage.vue?vue&type=script&lang=js&"
import style0 from "./Tele2InternetPage.vue?vue&type=style&index=0&id=788e59d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788e59d9",
  null
  
)

export default component.exports